import keyMirror from 'react-utils/keyMirror';
const RequestStatusTypes = keyMirror({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});
export default RequestStatusTypes;